<app-menu></app-menu>

<div style="background-color: #ffffff;">
    <div class="fundo-vpn-hero uk-light">
        <div class="uk-container uk-text-center">
            <h1 class="hero-standard-title" uk-scrollspy="cls: uk-animation-slide-top-small; delay: 100">
                NoAdsVPN
            </h1>
            <p class="uk-text-large" style="opacity: 0.9;" uk-scrollspy="cls: uk-animation-slide-bottom-small; delay: 300">
                Assista YouTube sem interrupções de anúncios.
            </p>
        </div>
    </div>
</div>

<div class="uk-padding uk-section-muted">
    <div class="uk-container">

        <div
            class="uk-child-width-1-2@m uk-child-width-1-1@s uk-grid-match uk-grid uk-text-left uk-margin-small-bottom uk-margin-small-top">
            <div>
                <div class="card uk-card  uk-border-rounded uk-card-body uk-width-1-1@m">
                    <h1 style="color:#234d77"> <b> Assista YouTube sem interrupções de anúncios </b></h1>
                    <img alt="" class="logo" src="img/no-ads-logo.png">

                    <p>Ao utilizar o <b>NoAdsVPN</b> ganha acesso a uma experiência sem anúncios do YouTube para
                        assistires seus conteúdos sem interrupções </p>
                        <div class="uk-child-width-1-2@l uk-child-width-1-1@s uk-grid-match uk-grid uk-text-center uk-margin-medium-top"
                        uk-grid>
            
                        <div>
                            <img class="selo" src="img/play.png" alt="">
            
                        </div>
                        <div>
                            <img class="selo" src="img/app.png" alt="">

                        </div>
                    </div>
                </div>

                <div class="uk-container uk-margin-small-top uk-margin-small-bottom ">
               
                </div>
            </div>

        </div>

    </div>

</div>




<div class="fundo-default">




    <div class="uk-container uk-margin-small-top uk-margin-medium-bottom ">
        <div class="uk-child-width-1-3@l uk-child-width-1-1@s uk-grid-match uk-grid uk-text-center uk-margin-medium-top"
            uk-grid>

            <div>
                <div
                    class="uk-card uk-card-default uk-border-rounded uk-card-hover uk-card-body uk-flex uk-flex-column">
                    <h3 class="uk-card-title"><b>Rápido</b></h3>
                    <p>Acesse a internet com uma navegação super ágil, sem interrupções. NoAdsVPN oferece uma conexão
                        rápida para você aproveitar o que há de melhor online.

                    </p>

                </div>
            </div>
            <div>
                <div
                    class="uk-card uk-card-default uk-border-rounded uk-card-hover uk-card-body uk-flex uk-flex-column">
                    <h3 class="uk-card-title"><b>Seguro</b> </h3>
                    <p>Navegue com tranquilidade! Nossa VPN garante criptografia de ponta e proteção de dados para que
                        sua privacidade esteja sempre em primeiro lugar.</p>

                </div>
            </div>
            <div>
                <div
                    class="uk-card uk-card-default uk-border-rounded uk-card-hover uk-card-body uk-flex uk-flex-column">
                    <h3 class="uk-card-title"><b> Acessível</b></h3>
                    <p>Pague apenas pelo precisa, temos planos diários. NoAdsVPN traz a você uma solução de qualidade
                        por um valor justo.</p>

                </div>
            </div>


        </div>
    </div>
    <app-rodape></app-rodape>

